<template lang="pug">
#selecionar-territorio
    el-input.mb-3(
        :placeholder="$t('mensagens.laudos.procurePorTerritorioOuPessoa')",
        prefix-icon='el-icon-search',
        v-model='filtroSelecionarTerritorio',
        @change='findAllTerritoriosSimplificado'
    )
    .conteudo
        .selecionados.mb-2(v-if='territoriosSelecionados')
            el-checkbox.ml-0(
                v-for='(territorio, index) in territoriosSelecionados',
                border,
                checked,
                @change='desselecionarTerritorio(index)',
                :key='territorio.id'
            )
                p.m-0
                    b {{ territorio.nome }}
                    br
                    em {{ territorio.totalRepresentantes }} {{ territorio.totalRepresentantes <= 1 ? $t('mensagens.laudos.pessoaMinusculo') : $t('mensagens.laudos.pessoasMinusculo') }}

        .nao-selecionados(v-if='territoriosNaoSelecionados')
            el-checkbox.ml-0(
                v-for='(territorio, index) in territoriosNaoSelecionados',
                border,
                @change='selecionarTerritorio(index)',
                :key='territorio.id'
            )
                p.m-0
                    b {{ territorio.nome }}
                    br
                    em {{ territorio.totalRepresentantes }} {{ territorio.totalRepresentantes <= 1 ? $t('mensagens.laudos.pessoaMinusculo') : $t('mensagens.laudos.pessoasMinusculo') }}

    .botao.marginButton(slot='footer')
        BaseButton(
            type='primary',
            size='small',
            @click='enviarIdsTerritoriosSelecionados'
        )
            | {{ $t('mensagens.comuns.adicionar') }}
</template>

<script>
import TerritorioService from '@/services/TerritorioService';
import formatters from '@/utils/formatters';
import { ordem } from '@/utils/ordenacao';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'SelecionarTerritorio',

    components: {
        BaseButton
    },

    props: {
        selecionados: {
            type: [],
            default() {
                return [];
            }
        }
    },

    emits: ['getIdsTerritoriosSelecionados'],

    data() {
        return {
            filtroSelecionarTerritorio: '',
            territoriosSelecionados: [],
            territoriosNaoSelecionados: []
        };
    },

    mounted() {
        this.ajustarJaSelecionados();
    },
    watch: {
        selecionados: function () {
            this.ajustarJaSelecionados();
        }
    },
    methods: {
        getFiltroSelecionarTerritorio() {
            if (this.filtroSelecionarTerritorio) {
                const cpfCnpj = formatters.documentoFormatToNumeral(
                    this.filtroSelecionarTerritorio
                );

                return cpfCnpj === ''
                    ? this.filtroSelecionarTerritorio
                    : cpfCnpj;
            }

            return '';
        },

        findAllTerritoriosSimplificado() {
            TerritorioService.findAllSimplificado(
                this.getFiltroSelecionarTerritorio()
            )
                .then(({ data }) => {
                    this.territoriosNaoSelecionados = data;
                    this.organizar();
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.laudos.ocorreuUmErroAoBuscarTerritorios')
                    });
                });
        },

        selecionarTerritorio(index) {
            this.territoriosSelecionados.push(
                this.territoriosNaoSelecionados[index]
            );
            this.territoriosNaoSelecionados.splice(index, 1);
            this.organizar();
        },

        desselecionarTerritorio(index) {
            this.territoriosNaoSelecionados.push(
                this.territoriosSelecionados[index]
            );
            this.territoriosSelecionados.splice(index, 1);
            this.findAllTerritoriosSimplificado();
        },

        organizar() {
            const filtro = a => {
                let encontrado = false;
                this.territoriosSelecionados.forEach(({ id }) => {
                    if (a.id === id) {
                        encontrado = true;
                    }
                });
                return !encontrado;
            };

            this.territoriosSelecionados.sort((a, b) => ordem(a, b));
            this.territoriosNaoSelecionados.sort((a, b) => ordem(a, b));

            this.territoriosNaoSelecionados =
                this.territoriosNaoSelecionados.filter(territorio =>
                    filtro(territorio)
                );
        },

        enviarIdsTerritoriosSelecionados() {
            const idsTerritoriosSelecionados = [];
            this.territoriosSelecionados.forEach(({ id }) => {
                idsTerritoriosSelecionados.push(id);
            });

            this.$emit(
                'getIdsTerritoriosSelecionados',
                idsTerritoriosSelecionados
            );
        },

        ajustarJaSelecionados() {
            this.territoriosSelecionados = [];
            this.selecionados.forEach(({ id, nome, representantes }) => {
                this.territoriosSelecionados.push({
                    id,
                    nome,
                    totalRepresentantes: representantes.length
                });
            });

            this.findAllTerritoriosSimplificado();
        }
    }
};
</script>

<style lang="scss" scoped>
#selecionar-territorio {
    .conteudo {
        height: 50vh;
        overflow-y: auto;
    }
    .selecionados,
    .nao-selecionados {
        display: flex;
        flex-direction: column;

        .el-checkbox {
            width: 100%;
            display: flex;
            align-items: center;

            .el-checkbox__label {
                display: flex;
                flex-direction: column;

                p {
                    line-height: 16px;
                }
            }

            em {
                font-weight: 200;
                font-size: 12px;
            }
        }
    }

    .botao {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
